const sliderElements = document.querySelectorAll(".new-featured-slider");
const sliderMianElements = document.querySelectorAll(".product-collection");
for (let index = 0; index < sliderElements.length; index++) {
    sliderElements[index].classList.add(`init-swiper-${index}`)
    sliderMianElements[index].querySelector(".swiper-button-next").classList.add(`swiper-button-next-${index}`)
    sliderMianElements[index].querySelector(".swiper-button-prev").classList.add(`swiper-button-prev-${index}`)

    setTimeout(() => {
        initSwiper(index)
    }, 100);
}

function initSwiper(index) {
    var swiper = new Swiper(`.init-swiper-${index}`, {
        slidesPerView: 4,
        spaceBetween: 10,
       
        loop: false,
        centeredSlides: false,
        navigation: {
          nextEl: `.swiper-button-next-${index}`,
          prevEl: `.swiper-button-prev-${index}`,
        },
       scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true,
        },
        breakpoints: {
          1300: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
          750: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          0: {
            slidesPerView: 2,
            spaceBetween: 20,
          }
        }
      });
}









